import { GetFeedIdUrlPath } from "../routes";
import { TOPIC_ID_BREAKROOM, TOPIC_ID_CAREER, TOPIC_ID_LIFESTYLE } from "./feed";

export const IsOnTheSearchPath = (url) => {
  return url === GetFeedIdUrlPath({ feedId: TOPIC_ID_CAREER }) ||
    url === GetFeedIdUrlPath({ feedId: TOPIC_ID_BREAKROOM }) ||
    url === GetFeedIdUrlPath({ feedId: TOPIC_ID_LIFESTYLE });
}